<mat-dialog-actions align="end" class="content">
    <button mat-button matDialogClose="close" class="btn-close">X</button>
</mat-dialog-actions>

<div class="container">
    <div class="aditional-info">
        <span class="tag-sale-detail"><strong>{{'sales.code' | translate}}:</strong> {{ data.sale?.code }}</span>
        <span class="tag-sale-detail" *ngIf="data.sale?.nfCeId"><strong>{{'sales.document' | translate}}:</strong> {{ ( data.sale?.costumerDocument ?
            data.sale?.costumerDocument : 'sales.documentNotInformed' | translate ) }}</span>
        <br>
        <span class="tag-sale-detail" *ngIf="data.sale?.nfCeId"><strong>NFCe:</strong> {{ data.sale?.nfCeId }}</span>
        <span class="tag-sale-detail" *ngIf="data.sale?.nfCeId"><strong>{{'sales.nfceSeries' | translate}}:</strong> {{ data.sale?.nfCeSeries }}</span>
        <span class="tag-sale-detail" *ngIf="data.sale?.pdvVersion"><strong>{{'sales.pdvVersion' | translate}}:</strong> {{ data.sale?.pdvVersion }}</span>
        <br *ngIf="data.sale?.nfCeId && data.sale?.nfCeSeries">
        <span class="tag-sale-detail" *ngIf="data.sale?.observation"><strong>Observação da Venda:</strong> {{data.sale?.observation}}</span>
    </div>
    <hr>
    <table mat-table class="demo-table" [dataSource]="data.saleProducts!">
        <ng-container matColumnDef="productCode">
            <th mat-header-cell *matHeaderCellDef>{{'sales.product.productCode' | translate}}</th>
            <td mat-cell *matCellDef="let element">{{element.productCode}}</td>
            <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>{{'sales.product.name' | translate}}</th>
            <td mat-cell *matCellDef="let element">{{element.name}}</td>
            <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <ng-container matColumnDef="unitPrice">
            <th mat-header-cell *matHeaderCellDef>{{'sales.product.unitPrice' | translate}}</th>
            <td mat-cell *matCellDef="let element">{{element.unitPrice | moneyFormatPipe}}</td>
            <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <ng-container matColumnDef="quantity">
            <th mat-header-cell *matHeaderCellDef>{{'sales.product.quantity' | translate}}</th>
            <td mat-cell *matCellDef="let element">{{element.quantity | stockQuantityFormatPipe:element.fractional}}</td>
            <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <ng-container matColumnDef="subtotal">
            <th mat-header-cell *matHeaderCellDef>{{'sales.product.subtotal' | translate}}</th>
            <td mat-cell *matCellDef="let element">{{element.subtotal | moneyFormatPipe}}</td>
            <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <ng-container matColumnDef="discount">
            <th mat-header-cell *matHeaderCellDef>{{'sales.product.discount' | translate}}</th>
            <td mat-cell *matCellDef="let element">{{element.discount | moneyFormatPipe }}</td>
            <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <ng-container matColumnDef="total">
            <th mat-header-cell *matHeaderCellDef>{{'sales.product.total' | translate}}</th>
            <td mat-cell *matCellDef="let element">{{element.total | moneyFormatPipe}}</td>
            <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns" class="row-height"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="row-height"></tr>
    </table>

    <table *ngIf="data.isCanceled" mat-table class="demo-table" [dataSource]="data.saleCanceled!">
        <ng-container matColumnDef="fullName">
            <th mat-header-cell *matHeaderCellDef>
                {{'sales.canceled.fullName' | translate}}
            </th>
            <td mat-cell *matCellDef="let element">
                {{element.fullName}}
            </td>
        </ng-container>

        <ng-container matColumnDef="cancelDate">
            <th mat-header-cell *matHeaderCellDef>
                {{'sales.canceled.cancelDate' | translate}}
            </th>
            <td mat-cell *matCellDef="let element">
                {{element.cancelDate | date: 'dd/MM/yyyy'}}
            </td>
        </ng-container>

        <ng-container matColumnDef="uuid">
            <th mat-header-cell *matHeaderCellDef>
                {{'sales.canceled.uuid' | translate}}
            </th>
            <td mat-cell *matCellDef="let element">
                {{element.uuid}}
            </td>
        </ng-container>

        <ng-container matColumnDef="cancelReason">
            <th mat-header-cell *matHeaderCellDef>
                {{'sales.canceled.cancelReason' | translate}}
            </th>
            <td mat-cell *matCellDef="let element">
                {{element.cancelReason}}
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumnsCanceled" class="row-height"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumnsCanceled;" class="row-height"></tr>
    </table>

    <!-- <div *ngIf="listProducts && listProducts.length > 0">
        <mat-paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
            (page)="paginationChange($event)" aria-label="Select page">
        </mat-paginator>
    </div> -->



</div>